module.exports = __webpack_public_path__ + "media/images/lb/575-540c20a3529ecb50ca81cf22c09255a1.svg";